module.exports = __webpack_public_path__ + "img/world.5e934fd8.svg";